import { useRootStore } from './useRootStore';

export function useScrollStore() {
  const { scrollStore } = useRootStore();
  return scrollStore;
}
